// 开发环境域名
//https://php-b2csaas.yixiangonline.com
const host_development = 'https://www.sxtjlm.com'

export default {
    // 版本
    version: '3.3.1',
    baseURL: process.env.NODE_ENV == 'production' ? '' : host_development,
    tencentMapKey: 'FWEBZ-WHSHV-IRFPO-UNMRL-5EUWV-BFBFW'
}
